import { Component } from '@angular/core';
import { CleverTapConstents } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-moratorium',
  templateUrl: './moratorium.component.html',
  styleUrls: ['./moratorium.component.scss'],
})
export class MoratoriumComponent {

   get selectedTenure(){
    return this.util.getCache('selectedTenure');
   }
   calcEmi:any;
   moratoriumPeriod:any;
   get isWithoutMoratoriumOption():boolean{
     return this.util.loanDetails && !this.util.loanDetails.loanCommercialDetails[0].emiBeforeMoratorium;
   }
   isWithMoratoriumSelected:boolean = true;
  constructor(public util: UtilService) {}
  ngOnInit() {
    this.getEmiData();
    this.util.userLoggedInEventCalled.subscribe(()=>{
      this.util.route('home');
      this.util.navigationHandler();
      this.getEmiData();
    })
   
  }
  getEmiData(){
    const loanDetails = this.util.loanDetails;
    if(!loanDetails) return;
    const body = {
      'loanId': loanDetails.loanId,
      'amount': this.selectedTenure?.amount,
      'tenorMonths': this.selectedTenure?.selectedTenor.tenor,
      'moratorium': loanDetails.hasMoratorium,
      'moratoriumPeriod': loanDetails.institutionInfo.moratoriumPeriod,
    };
    this.moratoriumPeriod = loanDetails.institutionInfo.moratoriumPeriod;
    this.util.handleRequests('put', this.util.getUrl('loan_emiCalculate'), body).then((res:any)=>{
      this.calcEmi = res.content;
      
    });
    
  }

  submit(){

    this.util.updateCommercials(this.selectedTenure, this.isWithMoratoriumSelected).then(()=>{
      this.util.cleverTapEventCall(CleverTapConstents.moratorium_selected,{
      'loanId':this.util.loanDetails.loanId,
      'productCode':this.util.loanDetails.productCategory
      });
      this.util.route('eligibility');
    });
    
  }

}
